module.exports = __webpack_public_path__ + "static/media/edsansiro-ambientes-002.b0a33196.jpg";